var _module_exports = "<div class=\"login-box\">\n  <login-form></login-form>\n</div>\n";;
var path = '/builds/observability/imm/signalview/src/legacy/common/security/login/loginmodal.tpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;